import { create } from 'zustand';
import { userApi } from '../services/userApi';

const getInitialUser = () => {
  try {
    const saved = localStorage.getItem('admin_user');
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    return null;
  }
};

export const useAuthStore = create((set, get) => ({
  isAuthenticated: !!localStorage.getItem('auth_token'),
  user: getInitialUser(),
  getToken: () => localStorage.getItem('auth_token'),
  isAdmin: () => {
    const user = get().user;
    return user?.roles?.includes('ROLE_ADMIN') || false;
  },
  login: async (email, password) => {
    const data = await userApi.login(email, password);
    const token = data?.token;
    if (!token) throw new Error('No token received from server');
    localStorage.setItem('auth_token', token);
    if (data.user) {
      localStorage.setItem('admin_user', JSON.stringify(data.user));
    }
    set({ isAuthenticated: true, user: data.user || null });
    return true;
  },
  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('admin_user');
    set({ isAuthenticated: false, user: null });
  }
}));
